import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-xl" />
              </span>
              <span className="font-heading font-black text-lg text-background-50">
                日皮视频
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-xs">
              最新影视资讯与精彩视频内容平台，聚合影视新闻、短视频与热门剪辑，陪你每天看点好的。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">
              <a href="/" className="cursor-pointer">内容分类</a>
            </h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">
              <a href="/about" className="cursor-pointer">关于与帮助</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  搜索视频
                </Link>
              </li>
              <li>
                <span className="text-sm text-background-300">使用说明</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">
              <a href="/about" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line" /> contact@ripitv.example
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-wechat-line" /> 微信公众号：日皮视频
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-weibo-line" /> @日皮视频
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 日皮视频 · 本网站内容为演示样例，不提供真实播放与下载
          </p>
          <p className="text-xs text-background-400">
            影视资讯 · 短视频 · 热门视频
          </p>
        </div>
      </div>
    </footer>
  );
}